import { sendCategoryFilterEvent } from '@ebay/presence-ui/lib/event-triggers';
import { ajax } from '@ebay/presence-ui/lib/ajax-handler';
import { get } from '@ebay/presence-ui/lib/object-helpers';

const KEY = 'str-ship-to';

export default class {
    onCreate(input) {
        const module = get(input, 'page.modules.SHIPPING_DESTINATION_MODULE.shippingToLocation', null);
        this.countries = get(module, 'maxView.countryGroup.entries', []);
        this.countrySelected = this.countries.find((country) => country.selected);
        this.zipCodePlaceholder = get(module, 'maxView.zipcode.accessibilityText', '');
        this.countryLabel = get(module, 'maxView.countryGroup.label.accessibilityText', '');
        this.zipCodeParamKey = get(module, 'maxView.zipParamKey', '');
        this.countryParamKey = get(module, 'maxView.countryGroup.paramKey', '');
        this.trackingData = JSON.stringify(get(module, 'maxView.goButton.action.trackingList.0', ''));
        this.state = {
            errorMsg: '',
            zipCodeDisable: get(this.countrySelected, 'fieldActions.0.doReact', '') === 'DISABLED',
            zipCodeValue: get(module, 'maxView.zipParamValue', ''),
            zipCodeAriaInvalid: false,
            zipCodeAriaDescribedBy: '',
            selected: get(this.countrySelected, 'paramValue', '')
        };
    }
    onInput() {
        return {
            countries: this.countries,
            zipCodePlaceholder: this.zipCodePlaceholder,
            countryLabel: this.countryLabel
        };
    }
    onMount() {
        const zipCodeComp = this.getComponent('zipcode');
        if (zipCodeComp) {
            this.zipCodeInput = zipCodeComp.getEl('input');
            this.countryValue = get(this.countrySelected, 'paramValue', '');
        }
        this.root = this.getEl(KEY);
    }
    selectCountry(event) {
        this.countryValue = event.selected[0];
        this.state.selected = this.countryValue;
        this.state.zipCodeDisable = get(this.countries[event.index], 'fieldActions.0.doReact', '') === 'DISABLED';
        this.state.zipCodeValue = '';
        if (this.state.zipCodeDisable) {
            this.moduleUpdate('');
        } else {
            this.zipCodeInput.focus();
        }
    }
    validateZip(event) {
        event.preventDefault();
        event.stopPropagation();
        const zipCodeValue = this.zipCodeInput.value;
        if (zipCodeValue.trim().length === 0) {
            this.moduleUpdate(zipCodeValue);
        } else {
            ajax({
                url: appendParams(this.zipCodeParamKey, zipCodeValue, this.countryParamKey, this.countryValue, true)
            }, {
                successCallBack: (resp) => {
                    if (!resp.success) {
                        this.handleInvalidZip(resp.message, zipCodeValue);
                    } else {
                        this.moduleUpdate(zipCodeValue);
                    }
                },
                errorCallBack: (err) => {
                    if (err) {
                        const message = err.message || err;
                        this.handleInvalidZip(message, zipCodeValue);
                    }
                }
            },
            3000);
            $(document).trigger('pulsar', this.trackingData);
        }
    }
    moduleUpdate(zipCodeInput) {
        // Clear error state
        this.state.errorMsg = '';
        this.state.zipCodeAriaInvalid = false;
        this.state.zipCodeAriaDescribedBy = '';

        this.state.selected = this.countryValue;
        this.state.zipCodeValue = zipCodeInput;
        const url = appendParams(this.zipCodeParamKey, zipCodeInput, this.countryParamKey, this.countryValue);
        sendCategoryFilterEvent({ url });
        setTimeout(() => {
            this.zipCodeInput.blur();
        }, 100);
    }
    handleInvalidZip(message, zipCodeValue) {
        this.state.errorMsg = message;
        this.state.zipCodeValue = zipCodeValue;
        this.state.zipCodeAriaInvalid = true;
        this.state.zipCodeAriaDescribedBy = 'str-ship-to__error';
        this.zipCodeInput.focus();
    }
}

function appendParams(zipCodeParamKey, zipCodeInput, countryParamKey, countryValue, isValidation) {
    const link = document.createElement('a');
    link.href = window.location.href;
    let queryString;
    if (link.search) {
        if (link.search.indexOf('_fcid') !== -1) {
            const urlParams = new URLSearchParams(link.search);
            urlParams.delete('_fcid');
            urlParams.delete('_stpos');
            queryString = `?${urlParams.toString()}&`;
        } else {
            queryString = `${link.search}&`;
        }
    } else {
        queryString = '?';
    }
    const params = [];
    if (!zipCodeInput !== undefined && zipCodeInput.length !== 0) {
        params.push(`${zipCodeParamKey}=${zipCodeInput}`);
    }
    params.push(`${countryParamKey}=${countryValue}`);
    if (isValidation) {
        params.push('_validateRequest=true');
    }
    queryString += params.join('&');
    return `https://${window.location.host}${link.pathname}${queryString}`;
}
